import { Button } from "@material-ui/core";
import { Launch } from "@material-ui/icons";
import { memo } from "react";
import { utils, writeFile } from "xlsx";
import { useResultadoExercicioService } from "../contexts/ResultadoExercicioContext";

const ExportButton = ({ data, filename }) => {
  const {
    columns,
    isGroupedByFinanceCategory,
    isConsolidated,
    cachedPeriodTotal,
  } = useResultadoExercicioService();
  const isDisabled = !data?.length;

  const createXLSXRecursiveBody = (rows, child, level) => {
    const totals = columns
      .filter((column) =>
        [
          "debit",
          "debitPerCent",
          "credit",
          "creditPerCent",
          "balance",
        ].includes(column.id)
      )
      .map((total) => child.total[total.id]);

    const blankColumns = isConsolidated
      ? []
      : Array.from({ length: columns.length - 5 }, () => "");

    const categoryRow = [
      "",
      `${"-".repeat(level + 1)}${child.group.description}`,
      ...blankColumns,
      ...totals,
    ];
    if (level > 0 || !child.group.id) rows.push(categoryRow);
    child.children?.forEach((nodeChild) =>
      createXLSXRecursiveBody(rows, nodeChild, level + 1)
    );

    child.accounts?.forEach((item) => {
      const row = [
        "",
        ...columns.map((column) =>
          column.id === "categoryDescription"
            ? ""
            : column?.format
            ? column?.format(item[column.id])
            : item[column.id]
        ),
      ];
      rows.push(row);
    });
  };

  const exportToXLSX = () => {
    const rows = [];
    const headersIds = {};

    const header = [
      "",
      ...columns.map((colum) => {
        headersIds[colum.id] = colum.id;
        return colum.label;
      }),
    ];

    rows.push(header);

    data.forEach((movement) => {
      if (isGroupedByFinanceCategory) {
        rows.push([movement.group?.description]);
      }

      createXLSXRecursiveBody(rows, movement, 0);

      if (isGroupedByFinanceCategory) {
        const financeGroupTotalLabel =
          movement.total.balance >= 0 ? "Lucro:" : "Prejuízo: ";
        const blankColumns = Array.from(
          { length: columns.length - 1 },
          () => ""
        );
        rows.push(
          [financeGroupTotalLabel, ...blankColumns, movement.total.balance],
          []
        );
      }
    });

    const totalBlankColumns = Array.from(
      { length: columns.length - 1 },
      () => ""
    );

    rows.push(["Resultado:", ...totalBlankColumns, cachedPeriodTotal?.balance]);

    const sheet = utils.aoa_to_sheet(rows);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, sheet, "Sheet1");
    writeFile(workbook, `${filename}.xlsx`);
  };

  return (
    <Button
      size="small"
      variant="contained"
      endIcon={<Launch />}
      style={
        isDisabled
          ? null
          : {
              backgroundColor: "#1d6f42",
              color: "#f4f4f4",
            }
      }
      onClick={exportToXLSX}
      disabled={isDisabled}
    >
      XLSX
    </Button>
  );
};

export default memo(ExportButton);
